import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import PropTypes from 'prop-types';

var ModalDialog =
/*#__PURE__*/
function (_Component) {
  _inherits(ModalDialog, _Component);

  function ModalDialog() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ModalDialog);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ModalDialog)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "onCancel", function (e) {
      /* istanbul ignore else */
      if (e && e.preventDefault) {
        e.preventDefault();
      }

      var onCancel = _this.props.onCancel;
      onCancel(e, null);
    });

    _defineProperty(_assertThisInitialized(_this), "stopPropagate", function (e) {
      e.stopPropagation();
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyPress", function (e) {
      var keyCode = e.keyCode;

      if (keyCode === 13) {
        _this.onCancel(e);
      }
    });

    return _this;
  }

  _createClass(ModalDialog, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          isBasic = _this$props.isBasic,
          className = _this$props.className,
          modalClassName = _this$props.modalClassName,
          nodeRef = _this$props.nodeRef;
      return React.createElement("div", {
        className: "tg-modal".concat(isBasic ? ' tg-modal-basic' : '', " ").concat(modalClassName),
        onClick: this.onCancel,
        onKeyPress: this.onKeyPress,
        tabIndex: -1,
        ref: nodeRef,
        role: "button"
      }, React.createElement("div", {
        className: className,
        role: "dialog"
      }, React.createElement("div", {
        className: "tg-modal-content",
        onClick: this.stopPropagate,
        role: "presentation"
      }, children)));
    }
  }]);

  return ModalDialog;
}(Component);

ModalDialog.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  modalClassName: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  nodeRef: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  isBasic: PropTypes.bool
};
ModalDialog.defaultProps = {
  children: null,
  nodeRef: null,
  className: 'tg-modal-dialog',
  isBasic: false,
  modalClassName: ''
};
export default ModalDialog;